"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var filterPages = function filterPages(newVisiblePages, totalPages) {
  return newVisiblePages.filter(function (newVisiblePage) {
    return newVisiblePage <= totalPages;
  });
};
var getVisiblePages = function getVisiblePages(page, total) {
  if (total && typeof total === 'number') {
    if (total < 7) {
      return filterPages([1, 2, 3, 4, 5, 6], total);
    }
    if (page % 5 >= 0 && page > 4 && page + 2 < total) {
      return [1, page - 1, page, page + 1, total];
    }
    if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
      return [1, total - 3, total - 2, total - 1, total];
    }
    return [1, 2, 3, 4, 5, total];
  }
  return [];
};

/**
 * The Pagination component allows an user to navigate in a content divided into pages.
 */
var Pagination = function Pagination(_ref) {
  var pages = _ref.pages,
    page = _ref.page,
    onPageChange = _ref.onPageChange,
    previousText = _ref.previousText,
    nextText = _ref.nextText;
  var _React$useState = _react.default.useState(getVisiblePages(null, pages)),
    visiblePages = _React$useState[0],
    setVisiblePages = _React$useState[1];
  var _React$useState2 = _react.default.useState(page + 1 || 1),
    activePage = _React$useState2[0],
    setActivePage = _React$useState2[1];
  _react.default.useEffect(function () {
    setVisiblePages(getVisiblePages(null, pages));
  }, [pages]);
  _react.default.useEffect(function () {
    setActivePage(page + 1);
  }, [page]);
  var changePage = function changePage(newPage) {
    setActivePage(newPage);
    var newVisiblePages = getVisiblePages(newPage, pages);
    setVisiblePages(filterPages(newVisiblePages, pages));
    if (typeof onPageChange === 'function') {
      onPageChange(newPage - 1);
    }
  };
  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-label": "Table navigation"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "uk-pagination"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "uk-pagination__link",
    disabled: activePage <= 1,
    color: "secondary",
    outline: true,
    onClick: function onClick() {
      return changePage(activePage - 1);
    },
    label: previousText,
    icon: "angle-left",
    "aria-disabled": activePage <= 1
  })), visiblePages && visiblePages.map(function (visiblePage, index, array) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: activePage === visiblePage ? 'uk-pagination__item active' : 'uk-pagination__item'
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      outline: activePage !== visiblePage,
      className: "uk-pagination__link",
      color: "secondary",
      onClick: function onClick() {
        return changePage(visiblePage);
      },
      label: array[index - 1] + 2 < visiblePage ? "..." + visiblePage : visiblePage.toString(),
      "aria-current": activePage === visiblePage ? 'page' : null
    }));
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "uk-pagination__link",
    disabled: !pages || activePage >= pages,
    color: "secondary",
    outline: true,
    onClick: function onClick() {
      return changePage(activePage + 1);
    },
    label: nextText,
    icon: "angle-right",
    iconPosition: "right",
    "aria-disabled": !pages || activePage >= pages
  }))));
};
Pagination.propTypes = {
  /**
   * Number of pages
   */
  pages: _propTypes.default.number,
  /**
   * Active page
   */
  page: _propTypes.default.number,
  /**
   * onPageChange event
   */
  onPageChange: _propTypes.default.func,
  /**
   * Text in the prev arrow
   */
  previousText: _propTypes.default.string,
  /**
   * Text in the next arrow
   */
  nextText: _propTypes.default.string
};
Pagination.defaultProps = {
  page: 0
};
var _default = exports.default = Pagination;